import { createReducer, on } from '@ngrx/store';
import { KioskMaintenanceDto } from 'src/app/api/models';
import { checkInsurerMaintenanceFailure, checkInsurerMaintenanceSuccess, checkKioskMaintenanceFailure, checkKioskMaintenanceSuccess, resetMaintenance } from './maintenance.actions';


export const maintenanceFeatureKey = 'maintenance';

export interface MaintenanceState {
  maintenance: KioskMaintenanceDto
}

export const initialState: MaintenanceState = {
  maintenance: undefined
};


export const maintenanceReducer = createReducer(
  initialState,

  on(checkKioskMaintenanceSuccess, checkInsurerMaintenanceSuccess, (state, { data }) => ({ ...state, maintenance: data })),
  on(checkKioskMaintenanceFailure, checkInsurerMaintenanceFailure, (state) => ({ ...state, maintenance: undefined })),

  on(resetMaintenance, () => initialState)

)
